gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, EasePack, TextPlugin);

const locoScroll = new LocomotiveScroll({
  el: document.querySelector(".smooth-scroll"),
  smooth: true,
  effects: true,
  tablet: { smooth: false },
  smartphone: { smooth: false },
});

locoScroll.on("scroll", ScrollTrigger.update);

ScrollTrigger.scrollerProxy(".smooth-scroll", {
  scrollTop(value) {
    return arguments.length
      ? locoScroll.scrollTo(value, 0, 0)
      : locoScroll.scroll.instance.scroll.y;
  },
  getBoundingClientRect() {
    return {
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },
  pinType: document.querySelector(".smooth-scroll").style.transform
    ? "transform"
    : "fixed",
});

ScrollTrigger.defaults({
  scroller: ".smooth-scroll",
});
// const darkHeader = (action) => {
//   const headerEl = document.getElementById("header");
//   if (action) {
//     headerEl.classList.add("dark");
//   } else {
//     headerEl.classList.remove("dark");
//   }
// };

let master = gsap.timeline();

// Example header timeline (empty or define animations here)
let header = gsap.timeline();

let Desktop = () => {
  let about = () => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".about",
        start: "top top",
      end: () => "+=1500",
        scrub: 0.3,
        pin: true,
        anticipatePin: 1,
        // markers: true,
        onEnter: () =>
          document
            .querySelector("#shopify-section-template--25041513447749__text_image_animation_3DKAGQ")
            .classList.add("my-class"),
        onLeave: () =>
          document
            .querySelector("#shopify-section-template--25041513447749__text_image_animation_3DKAGQ")
            .classList.remove("my-class"),
        onEnterBack: () =>
          document
            .querySelector("#shopify-section-template--25041513447749__text_image_animation_3DKAGQ")
            .classList.add("my-class"),
        onLeaveBack: () =>
          document
            .querySelector("#shopify-section-template--25041513447749__text_image_animation_3DKAGQ")
            .classList.remove("my-class"),
      },
    })
      .to(".overlay", 1, {
        width: "100%",
        // onComplete: () => darkHeader(false),
      })
      .to(".about .title span", { opacity: 0 })
      .to(".about .title", { scale: 0, top: "0%" })
      .fromTo(".detail", { autoAlpha: 0, top: "0%", yPercent: 0, scale: 0 }, { autoAlpha: 1, yPercent: 0, scale: 1 })
      .fromTo(".detail-sub", { autoAlpha: 0, top: "0%", yPercent: 0, scale: 0 }, { autoAlpha: 1, yPercent: 0, scale: 1 })
      .fromTo(".index-about-img", { autoAlpha: 0, top: "0%", yPercent: 0, scale: 0 }, { autoAlpha: 1, yPercent: 0, scale: 1 })
      .from(".about-branding", { text: "", delimiter: " ", autoAlpha: 1 })
      .from(".about-coding", { text: "", delimiter: " ", autoAlpha: 1 })
      .from(".about-design", { text: "", delimiter: " ", autoAlpha: 1 })
      .from(".about-designs_1", { text: "", delimiter: " ", autoAlpha: 1 })
      .from(".about-designs_2", { text: "", delimiter: " ", autoAlpha: 1 })
      .from(".about-designs_3", { text: "", delimiter: " ", autoAlpha: 1 })
      .from(".about-designs_4", { text: "", delimiter: " ", autoAlpha: 1 })
      .from(".about-designs_5", { text: "", delimiter: " ", autoAlpha: 1 });
      // .from(".about-solution", { text: "", delimiter: " ", autoAlpha: 1 });
    return tl;
  };

  let services = () => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".services", // fixed typo here
        start: "top top",
        end: "top top",
        pin: false,
        pinSpacing: false,
        scrub: 0.3,
        // onEnter: () => darkHeader(false),
        // onLeaveBack: () => darkHeader(false),
      },
    });
    return tl;
  };

  master.add(header).add(about()).add(services());
};

let Mobile = () => {
  let about = () => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".about",
        start: "top top",
        end: "+=2000",
        scrub: 0.3,
        // pin: true,
        anticipatePin: 1,
        onUpdate: (self) => {
          // darkHeader(false);
        },
      },
    })
      .to(".overlay", 1, {
        width: "100%",
        // onComplete: () => darkHeader(true),
      })
      .to(".about .title span", { opacity: 0 })
      .to(".about .title", { opacity: 0 })
      .fromTo(".smartphone", { autoAlpha: 0, yPercent: 0, scale: 0 }, { autoAlpha: 1, yPercent: 0, scale: 1 })
      .fromTo(".all-about-detail", { autoAlpha: 0, yPercent: 50 }, { autoAlpha: 1, yPercent: 15 });
    return tl;
  };

  let mobabout = () => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".mob-aboutdetail",
        start: "top top",
      },
    })
      .fromTo(".detail", { autoAlpha: 0, top: "0%", yPercent: 20 }, { autoAlpha: 1, yPercent: 0 })
      .fromTo(".detail-sub", { autoAlpha: 0, top: "0%", yPercent: 20 }, { autoAlpha: 1, yPercent: 0 })
      .fromTo(".about-four-points", { autoAlpha: 0, top: "0%", yPercent: 20 }, { autoAlpha: 1, yPercent: 0 });
    return tl;
  };

  let services = () => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".services",
        start: "top top",
        end: "top 0",
        pin: false,
        scrub: 0.3,
        pinSpacing: true,
      },
    });
    return tl;
  };

  master.add(header).add(about()).add(mobabout()).add(services());
};

if (window.innerWidth > 992) {
  Desktop();
  ScrollTrigger.refresh();
} else {
  Mobile();
  ScrollTrigger.refresh();
}

ScrollTrigger.addEventListener("refresh", () => locoScroll.update());

ScrollTrigger.refresh();